angular.module('dnecom')
    .directive('renderSort', ["$parse", function($parse) {
        return {
            link: function(scope, element, attrs) {
                var columnName = attrs.renderSort;

                if (scope.order.column == columnName) {
                    element.addClass('sorting_' + scope.order.dir);
                } else {
                    element.addClass('sorting');
                }

                scope.sortableColumns[columnName] = element;

                element.on('click', function(event) {
                    if (scope.order.column == columnName) {
                        element.removeClass('sorting_' + scope.order.dir);
                        if (scope.order.dir == 'desc') {
                            element.addClass('sorting_asc');
                        } else {
                            element.addClass('sorting_desc');
                        }
                    } else {
                        scope.sortableColumns[scope.order.column].removeClass('sorting_' + scope.order.dir);
                        scope.sortableColumns[scope.order.column].addClass('sorting');
                        element.addClass('sorting_desc');
                    }
                });
            }
        };
    }]);
